import React, { useEffect, useState } from "react";
import { Routes, Route } from "react-router-dom";
import CreateCampaign from "../Pages/CreateCampaign";
import CampaignsListGrid from "../Pages/CampaignDashboard";
import ProofTemplate from "../Pages/ProofTemplate";
import UploadContacts from "../Pages/UploadContacts";
import Home from "../Pages/Home.jsx";
import PrintContent from "../Pages/PrintContent.jsx";
import { Alert } from "react-bootstrap";
import CreateNewUser from "../Pages/CreateNewUser.jsx";
import AdminActivityLogs from "../Pages/AdminActivityLogs";
import { useAuth } from "react-oidc-context";
import Navbar from "../components/Navbar.jsx";
import "../CustomStyle.css";

const AppLayout = () => {
  const [authError, setAuthError] = useState(null);
  const [userDetails, setUserDetails] = useState({
    userRole: null,
  });

  const auth = useAuth();
  const BEARER = auth?.user?.access_token
    ? `Bearer ${auth?.user?.access_token}`
    : null;

  useEffect(() => {
    setAuthError(null);
    if (auth.user?.profile) {
      setUserDetails({
        userRole: auth.user.profile["custom:role"],
      });
    }
  }, [auth.user]);

  const signOutRedirect = () => {
    sessionStorage.removeItem("login_code");
    const clientId = process.env.REACT_APP_CLIENT_ID;
    const logoutUri = `${process.env.REACT_APP_REDIRECT_URI}/logout`;
    const cognitoDomain = process.env.REACT_APP_COGNITO_DOMAIN;

    const logoutUrl = `${cognitoDomain}/logout?client_id=${clientId}&logout_uri=${encodeURIComponent(
      logoutUri
    )}`;

    window.location.href = logoutUrl;
  };

  if (authError) {
    return (
      <Alert variant="danger" style={{ width: "80%", margin: "4%" }}>
        {authError}
      </Alert>
    );
  }

  return (
    <>
      {userDetails.userRole ? (
        <div className="app-layout">
          <Navbar
            userRole={userDetails.userRole}
            signOutRedirect={signOutRedirect}
          />

          <div className="content-container">
            <div className="content">
              <Routes>
                <Route path="/" element={<Home />} />
                <Route
                  path="/users"
                  element={
                    <CreateNewUser
                      userRole={userDetails.userRole}
                      bearerToken={BEARER}
                    />
                  }
                />

                <Route
                  path="/activity_logs"
                  element={
                    <AdminActivityLogs
                      userRole={userDetails.userRole}
                      bearerToken={BEARER}
                    />
                  }
                />

                <Route
                  path="/campaigns"
                  element={
                    <CreateCampaign
                      userRole={userDetails.userRole}
                      bearerToken={BEARER}
                    />
                  }
                />
                <Route
                  path="/contacts"
                  element={
                    <UploadContacts
                      userRole={userDetails.userRole}
                      bearerToken={BEARER}
                    />
                  }
                />
                <Route
                  path="/dashboard"
                  element={
                    <CampaignsListGrid
                      userRole={userDetails.userRole}
                      bearerToken={BEARER}
                    />
                  }
                />
                <Route
                  path="/proof_templates"
                  element={
                    <ProofTemplate
                      userRole={userDetails.userRole}
                      bearerToken={BEARER}
                    />
                  }
                />
                <Route
                  path="/print_collaterals"
                  element={
                    <PrintContent
                      userRole={userDetails.userRole}
                      bearerToken={BEARER}
                    />
                  }
                />
              </Routes>
            </div>
            <div className="footer-wrapper">
              <footer>
                &copy; {new Date().getFullYear()} Reachpersona.com. All Rights
                Reserved.
              </footer>
            </div>
          </div>
        </div>
      ) : (
        <Routes>
          <Route path="/*" element={<Home />} />
        </Routes>
      )}
    </>
  );
};

export default AppLayout;
